import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductSalesSummary } from '@hq-app/retailer-analytics/models/sales-summary';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductSalesSummaryResource implements DataResource<ProductSalesSummary> {
    private baseUrl: string;

    constructor(private http: HttpClient, private appSettings: AppSettings) {
        this.baseUrl = `${this.appSettings.apis.report}`;
    }

    getAll(): Observable<Array<ProductSalesSummary>> {
        const url = `${this.baseUrl}/top-products`;
        return this.http.get<Array<ProductSalesSummary>>(url);
    }
}
